// src/components/AssetSelect.jsx
//
// The one control for "which asset am I working on". Wide enough for a real
// asset name, and links to the project overview
// where assets are added and renamed.

import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Divider, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { useFile } from "../context/FileContext";
import { useIsGreek } from "../context/LanguageContext";
import { assetDisplayName } from "../utils/portfolio";

export default function AssetSelect({ size = "small", minWidth = 320, maxWidth = 560, label = "Asset", sx }) {
  const { assets, activeAsset, switchAsset } = useFile();
  const greek = useIsGreek();
  if (!assets?.length) return null;
  return (
    <FormControl size={size} sx={{ minWidth, maxWidth, width: "100%", ...sx }}>
      <InputLabel id="asset-select-label">{label}</InputLabel>
      <Select
        labelId="asset-select-label"
        label={label}
        value={activeAsset?.id || ""}
        onChange={(e) => {
          if (e.target.value && e.target.value !== "__manage__") switchAsset(e.target.value);
        }}
        renderValue={(v) => {
          const a = assets.find((x) => x.id === v);
          return (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
              <Typography component="span" noWrap sx={{ fontWeight: 700, minWidth: 0 }}>
                {a?.name ? assetDisplayName(a.name, greek) : "—"}
              </Typography>
            </Box>
          );
        }}
      >
        {assets.map((a) => (
          <MenuItem key={a.id} value={a.id}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}>
              <Typography sx={{ fontWeight: 600, flexGrow: 1 }}>{assetDisplayName(a.name, greek)}</Typography>
            </Box>
          </MenuItem>
        ))}
        <Divider />
        <MenuItem component={RouterLink} to="/project/overview" value="__manage__">
          <Typography sx={{ fontWeight: 600, color: "primary.main" }}>Manage assets…</Typography>
        </MenuItem>
      </Select>
    </FormControl>
  );
}
